import { createTheme } from '@mui/material/styles';
// import InformationIcon from './ui/icons/InformationIcon';
import { ReactComponent as Clock } from './ui/icons/Warning.svg';
import { ReactComponent as Info } from './ui/icons/information.svg';

const ClockIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <Clock width={24} height={24} fill="currentColor" {...props} />
);

const InformationIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <Info width={24} height={24} fill="currentColor" {...props} />
);

const theme = createTheme({
  components: {
    MuiAlert: {
      defaultProps: {
        iconMapping: {
          info: <InformationIcon />,
          warning: <ClockIcon />
        },
      },
    },
  },
  typography: {
    fontFamily: 'Causten, sans-serif',
  },
  palette: {
    primary: {
      main: '#6B988C',
      light: '#54786F',
    },
    secondary: {
      main: '#ffffff',
      light: '#edf1d6'
    },
    error: {
      main: '#D3756B',
    }
  }
});

export default theme;
